import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from 'src/environments/environment';
import { IUserActive } from './global/user-active.models';

@Injectable({
	providedIn: 'root'
})
export class MixpanelService {
	constructor() {
		// Generate new tokens at mixpanel.com, specifically (https://eu.mixpanel.com/project/3387805/app/settings#org/2508983/projects/detail/3397436)
		mixpanel.init(environment.mixpanelToken);
	}

	track(eventName: string, properties?: object): void {
		mixpanel.track(eventName, properties);
	}

	initializeUser(user: IUserActive): void {
		this.identify(user);
		this.setUserProperties(user);
	}

	identify(user: IUserActive): void {
		mixpanel.identify(user.IdUser);
	}

	setUserProperties(properties: any): void {
		const systemProperties = {
			$name: properties?.Name, 
			$email: properties?.Email,
		};
	
		const mergedProperties = { ...systemProperties, ...properties };
		mixpanel.people.set(mergedProperties);
	}
	
}
